<template>
    <div :class="getClass">
        <div class="page-header">
            <slot name="header"></slot>
        </div>
        <div class="page-body">
            <div class="page-body-wrapper">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page',
    data() {
        return {};
    },
    computed: {
        getClass() {
            return ['page'];
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.page {
    // 頁首
    .page-header {
        padding: ($header-height + 20px) 20px 25px 20px;
        transition: 0.2s;
        background-color: rgba(255, 255, 255, 0.5);
        margin-bottom: 20px;
        // border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        @media (min-width: 992px) {
            padding-top: 155px;
        }

        @media (min-width: 1200px) {
        }

        // 如果有 filter-bar 則取消底部 padding
        &.has-filter-bar {
            padding-bottom: 0;
        }

        // 頁面名稱
        .page-title {
            display: inline;
            padding: 0 0 0px 0px;
            margin: 0 0 15px 0;
            font-size: 15pt;
            height: 40px;
            line-height: 40px;
            vertical-align: middle;

            @media (min-width: 992px) {
                font-size: 17pt;
                padding: 0 0 0px 0;
            }

            .back-btn {
                width: 31px;
                height: 31px;
                line-height: 31px;
                padding: 0;
                vertical-align: top;
                margin-right: 7px;
                border: 0;
            }
        }
    }

    // 頁面主要功能區
    .page-main-actions {
        vertical-align: middle;
        margin-bottom: 0px;

        @media (min-width: 992px) {
            float: right;
            margin-bottom: 30px;
            text-align: right;
        }

        .search {
            width: 200px;
            margin: 0 10px 0 10px;

            @media (min-width: 992px) {
                width: 300px;
            }

            input {
                border-radius: 20px;
            }
        }
    }

    // 篩選列
    .page-filter-row {
        margin-bottom: 20px;
        // padding: 0 25px;
        width: 100%;
        overflow-x: auto;

        &::-webkit-scrollbar {
            width: 0px;
            background: transparent;
            /* make scrollbar transparent */
        }

        .el-dropdown-link {
            display: block;
            padding: 10px 0;
            margin: 0 22px;

            &:first-child {
                padding-left: 0;
                margin-left: 0;
            }

            .el-icon-arrow-down {
                font-size: 8px;
                transform: scale(0.85);
                margin-left: 10px;
            }
        }

        .el-select {
            margin-left: 12px;

            &:first-child {
                margin-left: 0;
            }
        }
    }

    // 頁面內容
    .page-body {
        // margin-top: 30px;
        padding-bottom: 70px;
        transition: 0.2s;

        @media (min-width: 992px) {
            // margin-top: 30px;
        }

        @media (min-width: 1200px) {
            // margin-top: 30px;
        }

        .page-body-wrapper {
            margin: 0 10px 0 10px;

            @media (min-width: 992px) {
                width: auto;
                margin: 0 30px 0 30px;
            }

            // @media (min-width: 1200px) {
            // width: auto;
            // margin: 0 60px 0 60px;
            // }
        }
    }

    .pages {
        margin: 30px 0;
        text-align: center;
    }

    .page-bottom-actions {
        text-align: center;
        margin: 15px 0;

        .submit-btn {
            width: 200px;
        }
    }
}
</style>
